/* Refurbished megamenu (desktop panel + mobile drawer).
   Series and models come from the same validated source, strict stock rule and URL format as the
   refurbished collection filters (view=pf-filter-data + PrimeFoneCollection core). Nothing from the mockup. */
(function () {
  'use strict';
  if (window.pfRefurbMenuInstalled) return;
  const configNode = document.querySelector('[data-pf-rmenu-config]');
  if (!configNode) return;
  window.pfRefurbMenuInstalled = true;
  const config = JSON.parse(configNode.textContent);
  const roots = [...document.querySelectorAll('[data-pf-rmenu]')];
  const ALL = '*', CACHE_KEY = 'pf-rmenu-v2', CACHE_MS = 10 * 60 * 1000;
  let catalog = null, pending = null, failed = false, selected = null, dataPending = null;

  const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  function icon(d, className) {
    const ns = 'http://www.w3.org/2000/svg', svg = document.createElementNS(ns, 'svg'), path = document.createElementNS(ns, 'path');
    for (const [name, value] of Object.entries({class: className || '', width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true'})) svg.setAttribute(name, value);
    path.setAttribute('d', d); svg.append(path); return svg;
  }
  const arrow = () => icon('M5 12h14m-6-6 6 6-6 6'), chevron = () => icon('m9 6 6 6-6 6'), check = () => icon('m5 12 5 5 9-10', 'pf-rmenu__check');
  const seriesName = model => model.match(/^iPhone (\d+|SE|X)/)?.[0] || model;
  const seriesLabel = name => name === ALL ? 'Alle refurbished iPhones' : name === 'iPhone SE' ? name : name + '-serie';
  // Editor text "Exact model: short neutral subtitle", one per line; empty is fine.
  const subtitles = Object.fromEntries(String(config.subtitles || '').split(/\r?\n/).map(line => line.split(':')).filter(parts => parts.length > 1).map(([model, ...text]) => [model.trim(), text.join(':').trim()]).filter(([model, text]) => model && text));

  function loadCore() {
    if (window.PrimeFoneCollection) return Promise.resolve(window.PrimeFoneCollection);
    return new Promise((resolve, reject) => {
      const script = el('script'); script.src = config.core;
      script.onload = () => window.PrimeFoneCollection ? resolve(window.PrimeFoneCollection) : reject(new Error('Filtercore ontbreekt.'));
      script.onerror = () => reject(new Error('Filtercore kon niet laden.'));
      document.head.append(script);
    });
  }
  // Same integrity checks as collection-filters.js: complete, consistent, no duplicates.
  async function fetchProducts() {
    // Snelheid 19-10: op de homepage staan de gegevens al in de HTML (sections/pfx-home-catalog, dezelfde Liquid als de view).
    // Zelfde controles als hieronder; klopt er iets niet, dan gewoon ophalen.
    const inline = document.querySelector('script[data-pf-collection-data][data-pf-inline]');
    if (inline) {
      try {
        const batch = JSON.parse(inline.textContent);
        const ids = new Set((batch.products || []).map(product => product.id));
        if (batch.version === 1 && batch.handle === 'refurbished-iphones' && batch.page === 1 && batch.pages === 1 && Number.isInteger(batch.total) && batch.total < 25000 && Array.isArray(batch.products) && batch.products.length === batch.total && ids.size === batch.total) return batch.products;
      } catch (error) { /* terug naar ophalen */ }
    }
    const collected = [], seen = new Set(), current = new URL(location.href); let pages = 1, total = null;
    for (let page = 1; page <= pages; page++) {
      const url = new URL(config.collectionUrl, location.origin);
      url.searchParams.set('view', 'pf-filter-data'); url.searchParams.set('sort_by', 'best-selling'); url.searchParams.set('page', page);
      for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      const response = await fetch(url, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-pf-collection-data]');
      if (!node) throw new Error('Collectiegegevens ontbreken.');
      const batch = JSON.parse(node.textContent);
      if (batch.version !== 1 || batch.handle !== 'refurbished-iphones' || batch.page !== page || !Number.isInteger(batch.total) || batch.total >= 25000 || !Number.isInteger(batch.pages) || batch.pages > 250 || (total !== null && (total !== batch.total || pages !== batch.pages))) throw new Error('Assortiment veranderde tijdens het laden.');
      total = batch.total; pages = Math.max(1, batch.pages);
      for (const product of batch.products) { if (seen.has(product.id)) throw new Error('Dubbele collectiegegevens.'); seen.add(product.id); collected.push(product); }
    }
    if (collected.length !== total) throw new Error('Collectie niet volledig geladen.');
    return collected;
  }
  // One shared request for the validated collection data (menu + homepage series and devices).
  function loadData() {
    if (!dataPending) dataPending = Promise.all([loadCore(), fetchProducts()]).catch(error => { dataPending = null; throw error; });
    return dataPending;
  }
  function summarize(core, products) {
    const data = core.hydrate(products, config.rules); // data.rows = strictly saleable variants only
    const base = new URL(config.collectionUrl, location.origin).href;
    const link = value => core.url(base, {...core.empty(), ...value});
    const series = [];
    for (const model of core.facets(data.rows, core.empty(), config.rules).model) {
      const name = seriesName(model);
      let entry = series.find(item => item.name === name);
      if (!entry) series.push(entry = {name, models: []});
      // Rows already exclude reviewed photos (image null) and multi-variant products without a variant photo.
      entry.models.push({name: model, url: link({model: [model]}), image: data.rows.find(row => row.model === model && row.image)?.image || null});
    }
    // Series thumbnail: a real photo of one of its saleable models (never a mockup image).
    series.forEach(entry => { entry.url = link({model: entry.models.map(m => m.name)}); entry.image = entry.models.find(m => m.image)?.image || null; });
    const conditions = core.conditions.filter(name => data.rows.some(row => row.condition === name)).map(name => ({name, url: link({condition: [name]})}));
    return {series, conditions};
  }
  function readCache() {
    try { const value = JSON.parse(sessionStorage.getItem(CACHE_KEY)); return value && value.url === config.collectionUrl && Date.now() - value.time < CACHE_MS ? value.catalog : null; } catch (error) { return null; }
  }
  function writeCache(value) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({time: Date.now(), url: config.collectionUrl, catalog: value})); } catch (error) { /* storage unavailable: keep in memory */ }
  }
  function ensure() {
    if (catalog) return Promise.resolve(catalog);
    if (pending) return pending;
    const cached = readCache();
    if (cached) { catalog = cached; renderAll(); return Promise.resolve(catalog); }
    failed = false; renderAll();
    pending = loadData()
      .then(([core, products]) => { catalog = summarize(core, products); writeCache(catalog); return catalog; })
      .catch(() => { failed = true; return null; })
      .finally(() => { pending = null; renderAll(); });
    return pending;
  }

  // Homepage sections reuse the same source, stock rule and series names (see home-catalog.js).
  window.PrimeFoneRefurbData = {load: loadData, catalog: ensure, rules: config.rules, seriesName, seriesLabel, neutral};

  const seriesKeys = () => [ALL, ...catalog.series.map(entry => entry.name)];
  const modelsFor = key => key === ALL ? catalog.series.flatMap(entry => entry.models) : (catalog.series.find(entry => entry.name === key)?.models || []);
  function image(model) {
    const media = el('span', 'pf-rmenu__media');
    if (model.image) {
      const img = el('img'); img.src = model.image; img.alt = ''; img.width = 560; img.height = 560; img.loading = 'lazy'; img.decoding = 'async';
      img.addEventListener('error', () => img.replaceWith(neutral()), {once: true}); media.append(img);
    } else media.append(neutral());
    return media;
  }
  function thumb(src) {
    const node = el('span', 'pf-rmenu__thumb'); node.setAttribute('aria-hidden', 'true');
    if (src) { const img = el('img'); img.src = src; img.alt = ''; img.width = 40; img.height = 40; img.loading = 'lazy'; img.addEventListener('error', () => img.remove(), {once: true}); node.append(img); }
    else { const svg = document.querySelector('[data-pf-rmenu-neutral]')?.content.firstElementChild?.cloneNode(true); if (svg) node.append(svg); }
    return node;
  }
  const seriesImage = key => key === ALL ? catalog.series.find(entry => entry.image)?.image || null : catalog.series.find(entry => entry.name === key)?.image || null;
  function neutral() {
    const placeholder = el('span', 'pf-product-placeholder'); placeholder.setAttribute('role', 'img'); placeholder.setAttribute('aria-label', 'Productfoto nog niet beschikbaar');
    const svg = document.querySelector('[data-pf-rmenu-neutral]')?.content.firstElementChild?.cloneNode(true);
    if (svg) placeholder.append(svg);
    placeholder.append(el('span', 'pf-product-placeholder__label', 'Foto volgt'));
    return placeholder;
  }
  function renderStatus(root, message, retry) {
    const grid = root.querySelector('[data-pf-rmenu-models]'), status = el('p', 'pf-rmenu__status', message);
    grid.replaceChildren(status);
    if (retry) { const button = el('button', 'pf-rmenu__retry', 'Opnieuw proberen'); button.type = 'button'; button.dataset.pfRmenuRetry = ''; grid.append(button); }
    root.querySelector('[data-pf-rmenu-conditions-wrap]').hidden = true;
    root.querySelector('[data-pf-rmenu-serieslink]').hidden = true;
  }
  function buildSeries(root) {
    // Built once per catalog; later selections only update attributes so keyboard focus is never lost.
    if (root.dataset.seriesBuilt) return;
    root.dataset.seriesBuilt = 'true';
    if (root.dataset.pfRmenu === 'desktop') {
      root.querySelector('[data-pf-rmenu-series]').replaceChildren(...seriesKeys().map(key => {
        const button = el('button', 'pf-rmenu__series-btn'); button.type = 'button'; button.dataset.pfSeries = key;
        button.append(thumb(seriesImage(key)), el('span', 'pf-rmenu__series-name', seriesLabel(key)), chevron()); return button;
      }));
    } else {
      root.querySelector('[data-pf-series-options]').replaceChildren(...seriesKeys().map(key => {
        const option = el('button', 'pf-rmenu__option'); option.type = 'button'; option.setAttribute('role', 'option'); option.tabIndex = -1; option.dataset.pfSeries = key;
        option.append(thumb(seriesImage(key)), el('span', 'pf-rmenu__option-name', seriesLabel(key)), check()); return option;
      }));
      root.querySelector('[data-pf-series-trigger]').disabled = false;
    }
    root.querySelector('[data-pf-rmenu-conditions]').replaceChildren(...catalog.conditions.map(condition => {
      const link = el('a', 'pf-rmenu__condition', condition.name); link.href = condition.url; return link;
    }));
  }
  function render(root) {
    if (!catalog) { renderStatus(root, failed ? 'De modellen konden niet worden geladen.' : 'Modellen laden…', failed); return; }
    if (!catalog.series.length) { renderStatus(root, 'Er zijn op dit moment geen refurbished iPhones beschikbaar.', false); return; }
    if (selected === null || !seriesKeys().includes(selected)) selected = catalog.series[0].name;
    buildSeries(root);
    root.querySelectorAll('[data-pf-series]').forEach(node => {
      const active = node.dataset.pfSeries === selected;
      if (node.getAttribute('role') === 'option') node.setAttribute('aria-selected', String(active)); else node.setAttribute('aria-pressed', String(active));
    });
    const title = root.querySelector('[data-pf-rmenu-title]'); if (title) title.textContent = selected === ALL ? seriesLabel(ALL) : 'Ontdek de ' + seriesLabel(selected);
    const current = root.querySelector('[data-pf-series-current]'); if (current) current.textContent = seriesLabel(selected);
    const currentThumb = root.querySelector('[data-pf-series-thumb]');
    if (currentThumb) currentThumb.replaceChildren(...thumb(seriesImage(selected)).childNodes);
    const seriesLink = root.querySelector('[data-pf-rmenu-serieslink]'), entry = catalog.series.find(item => item.name === selected);
    seriesLink.hidden = !entry; if (entry) seriesLink.href = entry.url;
    const cards = modelsFor(selected).map(model => {
      const card = el('a', 'pf-rmenu__card'); card.href = model.url; card.dataset.pfModel = model.name;
      const name = el('span', 'pf-rmenu__name', model.name); name.append(arrow());
      card.append(image(model), name);
      if (subtitles[model.name]) card.append(el('span', 'pf-rmenu__subtitle', subtitles[model.name]));
      return card;
    });
    // Mobile 2-column grid: a free last cell gets the advice tile.
    const advice = document.querySelector('[data-pf-rmenu-advice-card]');
    if (root.dataset.pfRmenu === 'mobile' && advice && cards.length % 2 === 1) cards.push(advice.content.firstElementChild.cloneNode(true));
    root.querySelector('[data-pf-rmenu-models]').replaceChildren(...cards);
    const wrap = root.querySelector('[data-pf-rmenu-conditions-wrap]'); wrap.hidden = !catalog.conditions.length;
  }
  function renderAll() { roots.forEach(render); }
  function choose(key) { selected = key; renderAll(); }

  // Mobile series dropdown: options below the field; outside tap closes without changing anything.
  const select = document.querySelector('[data-pf-series-select]');
  const trigger = select?.querySelector('[data-pf-series-trigger]'), options = select?.querySelector('[data-pf-series-options]');
  function setDropdown(open, focusOption) {
    if (!select) return;
    options.hidden = !open; trigger.setAttribute('aria-expanded', String(open)); select.classList.toggle('is-open', open);
    if (open && focusOption) (options.querySelector('[aria-selected="true"]') || options.querySelector('[role="option"]'))?.focus();
  }
  if (select) {
    trigger.addEventListener('click', () => setDropdown(options.hidden, true));
    options.addEventListener('click', event => {
      const option = event.target.closest('[data-pf-series]'); if (!option) return;
      choose(option.dataset.pfSeries); setDropdown(false); trigger.focus();
    });
    select.addEventListener('keydown', event => {
      if (options.hidden) return;
      const items = [...options.querySelectorAll('[role="option"]')], index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); setDropdown(false); trigger.focus(); }
      else if (event.key === 'ArrowDown') { event.preventDefault(); items[Math.min(items.length - 1, index + 1)]?.focus(); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); items[Math.max(0, index - 1)]?.focus(); }
      else if (event.key === 'Home') { event.preventDefault(); items[0]?.focus(); }
      else if (event.key === 'End') { event.preventDefault(); items[items.length - 1]?.focus(); }
      else if (event.key === 'Tab') setDropdown(false);
    });
    document.addEventListener('pointerdown', event => { if (!options.hidden && !select.contains(event.target)) setDropdown(false); }, true);
  }

  // Drawer main choices (Refurbished / Accessoires).
  const drawer = document.querySelector('[data-pf-drawer]');
  function showTab(name) {
    drawer.querySelectorAll('[data-pf-drawer-tab]').forEach(tab => { const active = tab.dataset.pfDrawerTab === name; tab.classList.toggle('is-active', active); tab.setAttribute('aria-pressed', String(active)); });
    drawer.querySelectorAll('[data-pf-drawer-panel]').forEach(panel => { panel.hidden = panel.dataset.pfDrawerPanel !== name; });
    const foot = drawer.querySelector('[data-pf-drawer-foot]'); if (foot) foot.hidden = name !== 'refurb';
    setDropdown(false);
    if (name === 'refurb') ensure();
  }
  if (drawer) {
    drawer.addEventListener('click', event => {
      const tab = event.target.closest('[data-pf-drawer-tab]');
      if (tab) showTab(tab.dataset.pfDrawerTab);
    });
    document.addEventListener('click', event => { if (event.target.closest('[data-pf-menu-toggle], [data-pf-search-open]')) ensure(); }, true);
  }

  roots.forEach(root => root.addEventListener('click', event => {
    const series = event.target.closest('.pf-rmenu__series-btn');
    if (series) choose(series.dataset.pfSeries);
    if (event.target.closest('[data-pf-rmenu-retry]')) ensure();
  }));
  const desktopTrigger = document.querySelector('[data-pf-rmenu-trigger]');
  if (desktopTrigger) for (const type of ['pointerenter', 'focusin', 'click']) desktopTrigger.addEventListener(type, ensure);
  renderAll();
})();
